import app from 'flarum/forum/app';

import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import Button from 'flarum/common/components/Button';

import LogInModal from 'flarum/forum/components/LogInModal';

export default class CustomFooter extends Component {
  addLinks: boolean = false;

  view() {
    return <footer class="Bhasvic-CustomFooter">{this.items().toArray()}</footer>;
  }

  items(): ItemList {
    const items = new ItemList();

    // Add footer items here!
    // Call `items.add('<unique key>', <your JSX>, <priority>)`
    // Items are ordered based on priority; high priority items will be first in the footer.

    items.add('copyright', <p>&copy; BHASVIC {new Date().getFullYear()}</p>, 100);

    if (!app.session?.user) {
      items.add(
        'login',
        <Button class="Button Button--link" onclick={() => app.modal.show(LogInModal, {})}>
          Admin log in
        </Button>,
        90
      );
    }

    return items;
  }

  static mount() {
    const container = document.getElementById('bhasvic-footer');

    // Fail safely if the container isn't found
    if (!container) return;

    // Mount this component to the `#bhasvic-navbar` container
    m.mount(container, CustomFooter);
  }

  oncreate(): void {
    this.addLinks = true;
    setTimeout(m.redraw, 0);
  }
}
